import type { IconData } from '@stacksjs/iconify-core'

export const re4x3: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h640v480H0z\"/><path fill=\"#000091\" d=\"M0 0h213.3v480H0z\"/><path fill=\"#e1000f\" d=\"M426.7 0H640v480H426.7z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default re4x3
